import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeOff } from '@app/modules/lookup/models/time-off.model';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { finalize } from 'rxjs/operators';
import { TimeOffService } from '@app/modules/time-off/services/time-off.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RefreshListener } from '@app/shared/models/refresh-listener';

@Component({
    selector: 'edit-time-off-type',
    templateUrl: './edit-time-off.component.html',
    styleUrls: ['./edit-time-off.component.scss']
})
export class EditTimeOffComponent implements OnInit {

    @Input() refreshListener: RefreshListener;

    private _timeOffTypeId: string;
    formData: any;
    @Input() set timeOffTypeId(value: string) {
        this._timeOffTypeId = value;
        this.getTimeOffTypeById(this._timeOffTypeId);
    }

    get timeOffTypeId(): string {
        return this._timeOffTypeId;
    }

    public timeOffType: TimeOff;
    filePath: SafeUrl;
    newIconFile: File | null = null;
    isLoading: boolean = true;
    formId: string = 'frm_Wv4eJ3x3xPuSRy';
    getFormData: boolean = false;
    formValid: boolean = false;
    formPristine: boolean;

    constructor(
        private timeOffService: TimeOffService,
        private snackbarService: SnackbarService,
        private overlayService: OverlayService,
        private domSanitizer: DomSanitizer,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.getTimeOffTypeById(this.timeOffTypeId);
    }

    private getTimeOffTypeById(id) {
        this.isLoading = true;
        this.timeOffService.getTimeOffTypeById(id).subscribe(
            timeOffType => {
                this.timeOffType = timeOffType;
                this.getIcon();
                this.createForm();
            }
        );
    }

    getIcon() {
        this.timeOffService.getTimeOffTypeIcon(this.timeOffType.id)
            .pipe(
                finalize(() => this.filePath = this.timeOffType ? this.timeOffType.image : null)
            )
            .subscribe(
                res => {
                    this.timeOffType.image = res?.url;
                }
            )
    }

    private createForm() {
        this.formData = {
            id: this.timeOffType ? this.timeOffType.id : null,
            name: this.timeOffType ? this.timeOffType.name : null,
            disabled: this.timeOffType ? this.timeOffType.disabled : false,
            allowSelectionWithNoPolicy: this.timeOffType ? this.timeOffType.allowSelectionWithNoPolicy : false
        };
    }

    formDataEmitted(formData) {
        this.save(formData);
    }

    formPristineEmitted(formPristine: boolean) {
        this.formPristine = formPristine;
    }

    formStatusUpdated(formValid) {
        this.formValid = formValid;
    }

    save(formData) {
        this.overlayService.show();

        const shouldUploadIcon = !!this.newIconFile;

        this.timeOffService.updateTimeOffType(this.timeOffTypeId, formData)
            .pipe(
                finalize(() => this.overlayService.hide())
            )
            .subscribe(
                () => {
                    if (shouldUploadIcon) {
                        this.timeOffService.postTimeOffTypeIcon(this.newIconFile, this.timeOffTypeId)
                            .subscribe(
                                () => this.handleSuccess(),
                                err => this.handleError(err)
                            );
                    } else {
                        this.handleSuccess();
                    }
                },
                err => this.handleError(err)
            );
    }

    handleSuccess() {
        this.refreshListener?.refresh?.();
        this.snackbarService.openSnackBar(`${this.translate.instant('SavedSuccessfully')}`, 'clear', 'success');
    }

    handleError(err) {
        console.log(err);
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
    }

    imagePreview(e) {
        const file = (e.target as HTMLInputElement).files[0];

        if (!file) {
            return;
        }

        this.newIconFile = file;

        const reader = new FileReader();
        reader.onload = () => {
            this.filePath = reader.result as string;
        };
        reader.readAsDataURL(file);
    }

    deleteType(): void {
        this.refreshListener?.showDeleteTypeConfirmation?.(this.timeOffType?.id);
    }
}
